import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CustomizeService } from '../../../../Services/Customize_settings/customize.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { NotificationService } from '../../../../Services/notification.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-gst-invoice-customization',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './gst-invoice-customization.component.html',
  styleUrls: ['./gst-invoice-customization.component.css']
})
export class GstInvoiceCustomizationComponent implements OnInit {
  selectedFirmId!: number;
  activeEditor: any = null;
  activeEditorLabel: string = '';
  editorPosition = { top: '0px', left: '0px' };
  invoiceSettings: any = this.getDefaultSettings();

  constructor(
    private customizeService: CustomizeService,
    private firmSelectionService: FirmSelectionService,
    private notificationService: NotificationService,
    private router:Router
  ) {}

  ngOnInit(): void {
    this.firmSelectionService.selectedFirmName$.subscribe((firm: any) => {
      if (firm?.id) {
        this.selectedFirmId = firm.id;
        this.loadLayoutSettings();
      }
    });
  }

  getDefaultSettings() {
    return {
      colors: {
        themeColor: '#006269', // Teal color from image
        outerBorder: '#006269',
      },
      header: {
        gstin: { text: 'GSTIN: 06ACEFM7839B1Z9', visible: true, color: '#006269' },
        taxInvoice: { text: 'TAX INVOICE', visible: true, color: '#000000' },
        firmTitle: { text: 'MEENA SILVER & CO', visible: true, color: '#006269', fontSize: 28 },
        address: { text: 'Ground floor, 199, Warn No 11, Masjid Wali Gali, Rania, Sirsa, Haryana', visible: true, color: '#4b5563' },
        pan: { text: 'PAN: ACEFM7839B', visible: true, color: '#000000' },
        mobile: { text: 'Mob: 86838 36136', visible: true, color: '#000000' },
        logo: { url: 'assets/images/minaseelver_logo.png', visible: true }
      },
      detailsLabels: {
        partyDetails: { text: 'Party Details:', visible: true, color: '#000000' },
        customerName: { text: 'CUSTOMER NAME', visible: true, color: '#000000' },
        customerAddress: { text: 'Customer Address', visible: true, color: '#94a3b8' },
        gstinUin: { text: 'GSTIN / UIN:', visible: true, color: '#000000' },
        invoiceNo: { text: 'Invoice No.', visible: true, color: '#000000' },
        dated: { text: 'Dated', visible: true, color: '#000000' },
        modeOfPay: { text: 'Mode of Pay', visible: true, color: '#000000' },
        partyMobile: { text: 'Party Mobile', visible: true, color: '#000000' },
        reverseCharge: { text: 'Reverse Charge', visible: true, color: '#000000' },
        placeOfSupply: { text: 'Place of supply', visible: true, color: '#000000' },
      },
      table: {
        headers: [
          { text: 'S.N.', visible: true },
          { text: 'Description of Item', visible: true },
          { text: 'HSN', visible: true },
          { text: 'Qty/Gm', visible: true },
          { text: 'Rate/Gm', visible: true },
          { text: 'Amount(₹)', visible: true }
        ],
        sampleItem: { text: 'Silver Ornaments', visible: true }
      },
      summary: {
        taxableAmount: { text: 'Taxable Amount', visible: true, color: '#000000' },
        cgst: { text: 'CGST @ 1.5%', visible: true, color: '#64748b' },
        sgst: { text: 'SGST @ 1.5%', visible: true, color: '#64748b' },
        total: { text: 'TOTAL', visible: true, color: '#000000' },
        adjustment: { text: 'Adjustment (Round Off)', visible: true, color: '#94a3b8' },
        grandTotal: { text: 'GRAND TOTAL', visible: true, color: '#006269', backgroundColor: '#ecfeff' }
      },
      footer: {
        termsTitle: { text: 'TERMS & CONDITIONS', visible: true, color: '#b91c1c' },
        termsList: [
          { text: '1. Goods once sold will not be taken back.', visible: true },
          { text: '2. Interest @ 18% p.a. will be charged if payment delayed.', visible: true },
          { text: '3. Subject to RANIA jurisdiction only.', visible: true }
        ],
        forFirm: { text: 'For Meena Silver & Co.', visible: true, color: '#006269' },
        signatory: { text: 'AUTHORIZED SIGNATORY', visible: true, color: '#94a3b8' },
        bankInfo: { text: 'BANK DETAILS: HDFC BANK, RANIA A/C: 50200116332671, IFSC: HDFC0002327', visible: true, color: '#ffffff' },
        signature: { url: '', visible: false }
      }
    };
  }

  openEditor(element: any, label: string, event: MouseEvent): void {
    event.stopPropagation();
    this.activeEditor = element;
    this.activeEditorLabel = label;

    const popupWidth = 280;
    const popupHeight = 250;
    let left = event.clientX + 10;
    let top = event.clientY + 10;

    if (left + popupWidth > window.innerWidth) left = event.clientX - popupWidth - 10;
    if (top + popupHeight > window.innerHeight) top = event.clientY - popupHeight - 10;

    this.editorPosition = { top: `${top}px`, left: `${left}px` };
  }

  triggerUpload(id: string) {
    document.getElementById(id)?.click();
  }

  onFileSelected(event: any, type: 'logo' | 'signature') {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        if (type === 'logo') {
          this.invoiceSettings.header.logo.url = e.target.result;
          this.invoiceSettings.header.logo.visible = true;
        } else {
          this.invoiceSettings.footer.signature.url = e.target.result;
          this.invoiceSettings.footer.signature.visible = true;
        }
      };
      reader.readAsDataURL(file);
    }
  }

  loadLayoutSettings(): void {
    this.customizeService.getUserSettings(this.selectedFirmId).subscribe({
      next: (res) => {
        const settings = res.data?.['gst_invoice_layout_settings'];
        if (settings) this.invoiceSettings = settings;
      }
    });
  }

  saveLayoutSettings(): void {
    const payload = { customize_firm_id: this.selectedFirmId, 'gst_invoice_layout_settings': this.invoiceSettings };
    this.customizeService.saveUserSettings(payload).subscribe({
      next: () => this.notificationService.showSuccess('Layout Saved Successfully', 'Success'),
      error: () => this.notificationService.showError('Failed to save layout', 'Error')
    });
  }

  resetLayoutSettings() {
    if(confirm('Reset all GST layout settings?')) this.invoiceSettings = this.getDefaultSettings();
  }

  removeSignature(event: MouseEvent) {
    event.stopPropagation();
    this.invoiceSettings.footer.signature.url = '';
    this.invoiceSettings.footer.signature.visible = false;
  }

  goBack(){
    this.router.navigate(['/gst-settings']);
  }
}